import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c(VDialog,{attrs:{"value":true,"persistent":"","max-width":"400"}},[_c(VCard,[_c(VCardTitle,[_c('span',{staticClass:"title-modal"},[_vm._v("Erro")])]),_c(VCardText,[_c(VAlert,{attrs:{"type":"error","color":"#e72c1f"}},[_vm._v(_vm._s(_vm.errorText))])],1),_c(VCardActions,[_c('div',{staticClass:"flex-grow-1 text-right"},[_c(VBtn,{staticClass:"btn-cancel",on:{"click":function($event){$event.preventDefault();_vm.visible = false}}},[_vm._v("Ok")])],1)])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }